import styled from 'styled-components'

export const PaymentMethodItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${properties => properties.theme.variables.colorBackground};
    border: 1px solid ${properties => properties.theme.variables.colorText};
    box-sizing: border-box;
    width: 100%;
    border-radius: 27px;
    button {
        cursor: pointer;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        font-family: ${properties => properties.theme.variables.fontFamily.description};
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;
        text-transform: capitalize;
        border: none;
        color: ${properties => properties.theme.variables.colorText};
        padding: 1rem 1.5rem;
        background: transparent;
        img {
            width: 24px;
            height: 24px;
            margin-right: 1rem;
        }
        svg {
            path {
                stroke: ${properties => properties.theme.variables.colorText};
                fill: ${properties => properties.theme.variables.colorText};
            }
        }
    }
    &:hover {
        transform: scale(1.01);
    }
`

export const RowContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    > svg {
        height: 24px;
        width: 24px;
        border-radius: 50%;
    }
`
